/**
 * The storage namespace outbound message media is uploaded under. The send path only honours attachment
 * references within this prefix, so it must match the server-side outbound-media namespace guard.
 */
export const ATTACHMENT_BLOB_PREFIX = 'customer-text/';

/**
 * Builds the blob name for an outbound message attachment. The file API requires the name part to be a
 * `<GUID>.<extension>` (a server-side guard rejects anything else), and the send path only honours references
 * within the `customer-text/` namespace, so the name is that prefix plus a fresh GUID carrying the source
 * file's extension -- derived from the file name, falling back to the MIME subtype, then to `jpg`.
 */
export function buildAttachmentBlobName(file: File): string {
    const nameExtension = file.name.includes('.') ? file.name.split('.').pop() : undefined;
    const typeSubtype = file.type.includes('/') ? file.type.split('/').pop() : undefined;
    const extension = (nameExtension || typeSubtype || 'jpg').toLowerCase();
    return `${ATTACHMENT_BLOB_PREFIX}${crypto.randomUUID()}.${extension}`;
}
